import { render, staticRenderFns } from "./OutlookLayout.vue?vue&type=template&id=2e94e11d&"
import script from "./OutlookLayout.vue?vue&type=script&lang=js&"
export * from "./OutlookLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports